import "mapbox-gl/dist/mapbox-gl.css";
import React, { useState } from "react";
import { Select, MenuItem } from "@mui/material";
import MapIcon from "@material-ui/icons/Map";
import { buildingMapStyleName } from "./Constants";

type MapStylesMenuProps = {
  setMapStyle: Function;
  addWms?: boolean;
};
export const MapStylesMenu: React.FC<MapStylesMenuProps> = ({ setMapStyle, addWms = false }) => {
  const [openSelect, setOpenSelect] = useState(false);

  return (
    <Select
      sx={{
        height: 37,
        "& .MuiSelect-iconOutlined": {
          right: "10px", // make sure the icon is centered
          backgroundColor: "rgba(255, 255, 255, 0.8)",
        },
      }}
      IconComponent={MapIcon}
      value={""} // it needs to have a default value
      open={openSelect}
      onClose={() => setOpenSelect(false)}
      onOpen={() => setOpenSelect(true)}
      onChange={(e) => {
        const mapStyle = `mapbox://styles/${e.target.value}`;
        setMapStyle(mapStyle);
      }}
    >
      <MenuItem value={"mapbox/streets-v11"}>Streets</MenuItem>

      {addWms ? <MenuItem value={"wmst+mapbox/streets-v11"}>Streets+Cadaster</MenuItem> : null}

      <MenuItem value={"mapbox/light-v10"}>Light</MenuItem>
      <MenuItem value={"mapbox/dark-v10"}>Dark</MenuItem>
      <MenuItem value={"mapbox/outdoors-v11"}>Outdoors</MenuItem>
      <MenuItem value={"mapbox/satellite-v9"}>Satellite</MenuItem>

      {addWms ? <MenuItem value={"wms+mapbox/satellite-v9"}>Satellite+Cadaster</MenuItem> : null}

      <MenuItem value={buildingMapStyleName}>CyStellarReale01</MenuItem>
    </Select>
  );
};
